import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Refresh = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb4d9__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g
            clipPath="url(#bb4d9__a)"
            style={{ mixBlendMode: 'passthrough' }}
          >
            <path
              fillRule="evenodd"
              d="M24 10c-7.732 0-14 6.268-14 14s6.268 14 14 14c6.52 0 12.005-4.46 13.56-10.498l3.873.997C39.435 36.261 32.39 42 24 42c-9.941 0-18-8.059-18-18S14.059 6 24 6c5.657 0 10.701 2.609 14 6.686V8h4v12H30v-4h5.491A13.985 13.985 0 0 0 24 10Z"
              style={{ mixBlendMode: 'passthrough' }}
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
